/**
 * Wiki Fantasy Theme Colors
 * Matches the overall Knuckleheads D&D application theme
 */

export const wikiTheme = {
  // Primary colors
  primary: '#d98d2a',        // Gold/Orange - important text, accents
  secondary: '#F5F5F5',      // Off-white - general text
  tertiary: '#A9A9A9',       // Gray - secondary text
  
  // Background colors
  dark: '#1c1c1c',           // Main background
  darkGray: '#2a2a2a',       // Slightly lighter dark
  mediumGray: '#333333',     // Card/element background
  lightGray: '#444444',      // Menu background
  hoverGray: '#555555',      // Hover state
  
  // Entry type colors (for badges and visualization)
  location: '#42a5f5',       // Blue - Locations
  person: '#66bb6a',         // Green - People
  item: '#ffa726',           // Orange - Items
  
  // Semantic colors
  success: '#66bb6a',
  warning: '#ffa726',
  danger: '#ef5350',
  info: '#42a5f5',
  
  // Font
  font: '"Georgia", serif',
  
  // Shadows
  shadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
  shadowHeavy: '0 4px 8px rgba(0, 0, 0, 0.7)',
};

export default wikiTheme;
